import linkifyHtml from 'components/text_editor_new/lib/linkify_html';
import serializeHtmlExternal from 'components/text_editor_new/lib/serialize_html_external';

/**
 * Produces the HTML body sent outside Gladly, with every bare URL wrapped in
 * an anchor. Chat's autolink plugin only hooks typing and pasting, so a URL
 * arriving from an inserted Answer is linked only here.
 *
 * @param editor
 * @returns {string}
 */
export default function serializeHtmlBody(editor) {
  // Linkify after serialization, when variables have flattened to text, so a
  // URL built from them matches whole.
  return linkifyHtml(serializeHtmlExternal(editor));
}
